<ng-template #emailPreviewModal>
  <div class="modal-body">
    <div class="ratio" style="--bs-aspect-ratio: 141%;">
      <iframe
        [srcdoc]="previewHtml"
      ></iframe>
    </div>
  </div>
</ng-template>
